import script from "./RadioButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioButton.vue?vue&type=script&setup=true&lang=js"

import "./RadioButton.vue?vue&type=style&index=0&id=30859531&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30859531"]])

export default __exports__